import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { setPageTitle } from "@/components/app-shell/app-shell";
import MetricCards, {
  MetricsLoading,
} from "@/components/dashboard/metric-cards";
import ProtectionIndicator from "@/components/dashboard/protection-indicator";
import { EndpointsTable } from "@/components/dashboard/quickview-table/endpoints-table";
import { NoEDRTable } from "@/components/dashboard/quickview-table/no-edr-table";
import { TechniquesTable } from "@/components/dashboard/quickview-table/techniques-table";
import { ThreatsTable } from "@/components/dashboard/quickview-table/threats-table";
import Timeline from "@/components/dashboard/timeline-graph/timeline";
import { authorizeFeatures } from "@/lib/authorize-feature";
import { getActivityQuery } from "@/lib/validators";

export const Route = createFileRoute("/_app/dashboard_/")({
  beforeLoad: async ({ context }) => {
    setPageTitle("Dashboard");
    await authorizeFeatures(context, ["detect"]);
  },
  loaderDeps: () => {
    return { query: getActivityQuery() };
  },
  component: DashboardPage,
});

function DashboardPage() {
  const { query } = Route.useLoaderDeps();
  return (
    <main>
      <section className="flex flex-col gap-4 bg-secondary-background px-4 py-4 md:flex-row dark:drop-shadow-[12px_12px_15px_rgba(0,0,0,0.25)]">
        <ProtectionIndicator query={query} />
        <Timeline />
      </section>
      <section className="px-4 pt-6">
        <Suspense fallback={<MetricsLoading />}>
          <MetricCards />
        </Suspense>
      </section>
      <section className="px-4 py-6">
        <TableContainer />
      </section>
    </main>
  );
}

export default function TableContainer() {
  const { query } = Route.useLoaderDeps();
  return (
    <>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div className="flex flex-col gap-4">
          <span className="text-base">Your top concerning threats:</span>
          <ThreatsTable query={query} />
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-base">Poorest performing endpoints:</span>
          <EndpointsTable query={query} />
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-base">Your top concerning techniques:</span>
          <TechniquesTable query={query} />
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-base">Endpoints without EDR detected:</span>
          <NoEDRTable query={query} />
        </div>
      </div>
    </>
  );
}
